<template>
	<div class="client-card" v-if="client">
		<div class="d-flex">
			<div class="side-icon">
				<b-avatar size="sm"></b-avatar>
			</div>
			<div class="data">
				<h3>{{ client.name }} {{ client.lastname }}</h3>
				<p>
					{{ client.email }} <br />
					{{ client.phone.national }} <br />
				</p>
			</div>
		</div>
		<div class="d-flex" v-if="client.addressStreet || client.addressCity || client.addressCountry">
			<div class="side-icon">
				<div class="icon icon-location"></div>
			</div>
			<div class="data">
				<p>
					{{ client.addressStreet }} <br />
					{{ client.addressCity }}
					<span v-if="client.addressCountry">{{ client.addressCountry.name }} <br /></span>
				</p>
			</div>
		</div>
		<div class="d-flex">
			<a v-if="client.phone" class="btn btn-xs btn-outline-light ml-3" target="_blank" :href="`tel:${client.phone.international}`">Llamar</a>
			<a v-if="client.phone" class="btn btn-xs btn-outline-light ml-2" target="_blank" :href="`https://wa.me/${client.phone.international.replace(/\s/g, '')}?text=Hola`">Enviar whatsapp</a>
			<a class="btn btn-xs btn-outline-light ml-2" target="_blank" :href="`mailto:${client.email}?subject=Orden de compra #${order.code}`">Enviar email</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ClientCard',
	props: ['client', 'order'],
}
</script>
<style scoped>
.client-card {
}
.client-card .side-icon {
	width: 46px;
	display: flex;
	justify-content: center;
}
.client-card .side-icon .icon {
	font-size: 18px;
	color: #666;
}
.client-card .data {
	flex-grow: 1;
}
.client-card h3 {
	font-size: 16px;
}
.client-card p {
	line-height: 16px;
}
</style>
